import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsEBikeRideNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 2.5v-1h-1V1h-1a2 2 0 00-1.93 1.5H2A1.5 1.5 0 00.5 4v2.99A1.523 1.523 0 002 8.5h1.9a3.5 3.5 0 103.545 4H8.54a3.5 3.5 0 102.42-3.85L9.83 6.5H11a.5.5 0 01.5.5h1A1.5 1.5 0 0011 5.5H8.17l1.05 2H6.127l-.527-1h.98l-.54-1H3.05l.53 1h.884L5 7.5H2.009a.517.517 0 01-.51-.51V4a.5.5 0 01.5-.5h10.072A2 2 0 0014 5h1v-.5h1v-1h-1v-1zM4 14.49a2.5 2.5 0 010-5c.11.002.221.012.33.028L3.22 11.59l.48.91h2.747A2.5 2.5 0 014 14.49zm.4-2.99l1.368-2.546L7.122 11.5zM12 9.49a2.5 2.5 0 11-2.233 1.372 2.47 2.47 0 01.753-.882l1.32 2.51h1.13l-1.54-2.93a2.12 2.12 0 01.57-.07zM7.02 8.5h2.72l.31.59a3.44 3.44 0 00-1.51 2.41h-.286l-1.595-3zm-2.19.09l-.006.01a3.492 3.492 0 00-.708-.1h.764z"
        fill=""
      />
    </svg>
  )
);
SvgSportsEBikeRideNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsEBikeRideNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsEBikeRideNormalXsmall;
